/**
 * @file Interface d'horloge murale injectee dans le core (jamais Date.now() dans core/) + horloge manuelle pour tests.
 */

export interface WallClock {
  /** Millisecondes epoch (UTC). Utilise pour hors-ligne, resets quotidiens, regeneration de tickets. */
  nowMs(): number;
}

/** Horloge controlee manuellement (tests, simulation hors-ligne). */
export class ManualClock implements WallClock {
  constructor(private ms = 0) {}
  nowMs(): number {
    return this.ms;
  }
  set(ms: number): void {
    this.ms = ms;
  }
  advance(deltaMs: number): void {
    this.ms += deltaMs;
  }
}

export const MS_PER_SECOND = 1000;
export const MS_PER_HOUR = 3_600_000;
export const MS_PER_DAY = 86_400_000;

/** Numero de jour UTC (entier) : cle de reset quotidien. */
export const dayKey = (ms: number): number => Math.floor(ms / MS_PER_DAY);
/** Numero de semaine UTC commencant le lundi (1970-01-05 est un lundi). */
export const weekKey = (ms: number): number => Math.floor((ms - 4 * MS_PER_DAY) / (7 * MS_PER_DAY));
